module.exports = __webpack_public_path__ + "dist/assets/img/prototypage.24dd3c1b.svg";